import React from 'react'
import Order from './Order'

const index = () => {
  return <Order />
}

export default index